import { useSelector } from "react-redux";
import { getIsLockerShop } from "@store/selectors/store";

import styles from "./main.module.scss";

const SwagCartNote = ({ noteText, className = "" }: { noteText: string; className?: string }) => {
  const isLockerShop = useSelector(getIsLockerShop);

  if (!isLockerShop) return null;

  return <div className={`${styles.refundNote} ${className}`}>{noteText}</div>;
};

export default SwagCartNote;
